module.exports = (test, root) => root && test instanceof root;
